import { Notification } from '@vfde-brix/ws10/notification';
import { startAppListening } from '../../../app/listener';
import { mountNotification } from '../../../components/Notification';
import { selectCustomerConfig } from '../../app/slice';
import { selectIsTradeInSelected } from '../slice';
import { RootState } from '../../../app/store';

/**
 * Mounts a Notification
 */
export const mountNotificationForHardwareOnly = (containerId: string): Notification | null => {
    const notification = mountNotification(containerId);

    /* istanbul ignore if */
    if (!notification) {
        return null;
    }

    listenForUpdates(notification);

    return notification;
};

const listenForUpdates = (notification: Notification) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsTradeInSelected(currentState) !== selectIsTradeInSelected(previousState)
            || selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
        ,
        effect: (_action, listenerApi) => {
            const currentState = listenerApi.getState();
            const previousState = listenerApi.getOriginalState();
            update(notification, currentState, previousState);
        },
    });
};

/**
 * Updates the tradeIn suggestInput notification based on the given state
 */
const update = (notification: Notification, currentState: RootState, previousState: RootState): void => {
    const isTradeInSelected = selectIsTradeInSelected(currentState);
    const currentCustomerConfig = selectCustomerConfig(currentState);
    const previousCustomerConfig = selectCustomerConfig(previousState);
    const { isHardwareOnly: currentIsHardwareOnly } = currentCustomerConfig;
    const { isHardwareOnly: previousIsHardwareOnly } = previousCustomerConfig;
    const shouldShowNotification =
        isTradeInSelected
        && currentIsHardwareOnly
        && !previousIsHardwareOnly
    ;

    notification.toggleContainer(!shouldShowNotification);
};
